<div class="print-show-block print-info print-page-break-after">
    <h2 class="portada-logo" *ngIf="asignatura"><ogr-icon name="{{ asignatura.icono }}" class="icono"></ogr-icon></h2>
    <h2 *ngIf="asignatura">{{ asignatura.asignatura }}</h2>
    <h1>{{ nombreEvaluacion }}</h1>
    <p class="subtitle" *ngIf="evaluacion">
        <label>Forma:</label>
        <span class="value">&nbsp;{{ evaluacion.id }}</span>
    </p>
</div>
